<div class="mt-2">

  <!-- RANGE TABS -->
  <mat-tab-group
    animationDuration="0ms"
    class="mt-2"
    (selectedTabChange)="selectedTabChange($event)">

    <mat-tab label="Last 4 Hrs"></mat-tab>
    <mat-tab label="Last 24 Hrs"></mat-tab>
    <mat-tab label="Last 7 Days"></mat-tab>
    <mat-tab label="This Month"></mat-tab>
    <mat-tab label="Last Month"></mat-tab>

  </mat-tab-group>

  <!-- SEARCH -->
  <form [formGroup]="form">
    <mat-form-field appearance="outline"
                    class="search-field"
                    floatLabel="never">

      <mat-icon matPrefix>search</mat-icon>

      <input
        matInput
        type="text"
        formControlName="search"
        placeholder="Search message..."
        autocomplete="off" />

      <button
        *ngIf="form.get('search')?.value"
        mat-icon-button
        matSuffix
        (click)="form.get('search')?.setValue('')">
        <mat-icon>close</mat-icon>
      </button>

    </mat-form-field>
  </form>

  <!-- TABLE -->
  <div class="device-table w-100 overflow-hidden">

    <table
      mat-table
      [dataSource]="_dataSource"
      matSort
      class="w-100 d-md-table d-block overflow-auto">

      <!-- MESSAGE -->
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef> Message </th>
        <td mat-cell *matCellDef="let row">
          {{ row.msg }}
        </td>
      </ng-container>

      <!-- TIMESTAMP -->
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef> Timestamp </th>
        <td mat-cell *matCellDef="let row">
          {{ row.t * 1000 | date:'yyyy-MM-dd HH:mm:ss' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <!-- PAGINATOR -->
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
      (page)="handlePageEvent($event)">
    </mat-paginator>

  </div>
</div>